var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPreemMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0-6.6148-5.3852-12-12-12S0 5.3852 0 12v11.0469C0 23.5711.429 24 .9531 24H12c6.6148 0 12-5.3852 12-12z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8614 12c0-1.5773-1.2841-2.8614-2.8614-2.8614-1.5773 0-2.8614 1.2841-2.8614 2.8614v2.6341a.228.228 0 00.2273.2273H12c1.5773 0 2.8614-1.2841 2.8614-2.8614z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.4864 2 2 6.4864 2 12v9.7727A.228.228 0 002.2273 22h3.0386a.228.228 0 00.2273-.2273V12c0-3.5886 2.9182-6.5068 6.5068-6.5068S18.5068 8.4114 18.5068 12 15.5886 18.5068 12 18.5068H9.366a.228.228 0 00-.2274.2273v3.0386A.228.228 0 009.366 22H12c5.5136 0 10-4.4864 10-10S17.5136 2 12 2z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2,
    y1: 22,
    x2: 2,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D10056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0D6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 2,
    y1: 22,
    x2: 2,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D10056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED0D6C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPreemMarker);
export default __webpack_public_path__ + "static/media/Map-Preem-Marker.ae2b77b3c4eae7c3fe02e07b1b903981.svg";
export { ForwardRef as ReactComponent };